var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default',[_c('div',{staticClass:"wrapper"},[_c('div',{},[_vm._t("default")],2)]),_c('div',{staticClass:"clear"})])}
var staticRenderFns = []

export { render, staticRenderFns }